import React from 'react';

import { Children } from '../types';
import { useConfig } from './provider';

export type Props = {
    className?: string;
    to: string;
    title?: string;
} & Children;

export const Link = ({ className, children, to, title }: Props): React.ReactElement => {
    const { link: Component } = useConfig();
    return (
        <Component className={className} to={to} title={title}>
            {children}
        </Component>
    );
};
